import { SET_FIRST_CLICK } from './../const';

export default (firstClick) => {
  return {
    type: SET_FIRST_CLICK,
    firstClick: firstClick
  }
};
